<template>
  <div v-if="overall" class="teacher-item-review" v-on="$listeners">
    <BaseIcon name="star" :color="color" size="xs" />
    <span class="teacher-item-review__score">
      <span>{{ overall }}/{{ max }}</span>
    </span>
    <span v-if="showLabel" class="teacher-item-review__label">
      {{ $t('labels.score') }}
    </span>
    <span v-if="!justOverall" class="text-body-1">|</span>
    <span v-if="!justOverall" :class="['teacher-item-review__num', numClass]">
      <span>{{ total }}</span>
    </span>
    <BaseButton
      v-if="!justOverall"
      :color="linkColor"
      flat
      light
      dense
      underline
      :label="$t('actions.reviews')"
      size="sm-xs"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TeacherListItemsReview',
  inject: ['teacher'],
  props: {
    justOverall: {
      type: Boolean,
      default: false
    },
    linkColor: {
      type: String,
      default: 'primary'
    },
    showLabel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('local', ['getTutorListDesignColor']),
    color () {
      return this.teacher?.designColor || this.getTutorListDesignColor
    },
    overall () {
      return this.teacher.statistics?.feedbacks?.score
    },
    max () {
      return this.teacher.statistics?.feedbacks?.max
    },
    total () {
      return this.teacher.statistics?.feedbacks?.total
    },
    numClass () {
      return this.linkColor ? `text-${this.linkColor}` : 'text-primary'
    }
  }
}
</script>

<style scoped lang="scss">
.teacher-item-review {
  @apply flex items-center lg:space-x-1 space-x-2 text-body-1
  text__caption-xs--bold lg:text__body-2-xs--semibold cursor-pointer;
  &__score {
    @apply  text-body-1;
  }
  &__num {
    @apply flex space-x-[2px];
  }
  &__label {
    @apply text__caption-xs--regular lg:text__body-2-xs--regular text-body-2;
  }
}
</style>
